module.exports = __webpack_public_path__ + "static/media/Vol.c2f9719b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Vol.png
// module id = 88
// module chunks = 0